import { postAjax, getAjax } from "./ajax";
import store from "../store";
import router from "../router";

export function getUserInfo() {
	getHeadNav();
	let url = "Api/User/GetUserInfo";
	postAjax(url)
		.then(function (data) {
			store.commit("setUserInfo", data.Data);
			store.commit("setLoginStatus", true);
		})
		.catch(() => {
			// that.$message.error("网络异常，请刷新后在试");
		});
}

export function userOut(path) {
	postAjax("/api/Sys/Out")
		.then(data => {
			store.commit("uesrOut");
			if (path !== "/home") {
				router.push("/home");
			}
			localStorage.clear();
			sessionStorage.clear();
		})
		.then(() => {});
}

export function getHeadNav() {
	let url = "Api/Lnc/Get";
	if (store.state.navAry.length > 0) return;
	getAjax(url, 1)
		.then(data => {
			const NavAry = data.Data.filter(item => item.LotteryList.length > 0);
			store.commit("setNavAry", NavAry);
		})
		.catch(() => {
			// that.$message.error("网络异常，请刷新后在试");
		});
}

// 获取第三方游戏平台分类类型
export function getThirdGameCategory() {
	let url = "api/Sys/GetThirdGameCategory";
	postAjax(url, 1)
		.then(data => {
			store.commit("setThirdGameCategory", data.Data);
		})
		.catch(() => {});
}

// 获取系统所有游戏平台
export function getThirdGame() {
	let url = "api/ThirdGame/GetGames";
	postAjax(url, 1)
		.then(data => {
			store.commit("setThirdGame", data.Data);
		})
		.catch(() => {});
}
// TODO 捕鱼游戏怎么拿??

// 获取用户收藏彩种集合
export function getUserFavoritesLotteryList() {
	let url = "/api/User/GetUserFavoritesLotteryList";
	getAjax(url)
		.then(data => {
			store.commit("setUserFavoritesLotteryList", data.Data);
		})
		.catch(() => {});
}

export default {
	getUserInfo,
	userOut,
	getHeadNav,
};



// WEBPACK FOOTER //
// ./src/util/getdata.js